import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useAppSelector } from "../app/hooks";
import { UserRole, isAdminRole } from "../app/userSlice";
import { AdminSessionLoading, useAdminSessionGate } from "./AdminSessionGate";

export default function RequireCourseOrAdminSession() {
	const { course, school, district, role, isAdminSessionSynced } = useAppSelector(
		(state) => state.user
	);
	const navigate = useNavigate();
	const shouldGate = useAdminSessionGate();

	const courseRequired = !isAdminRole(role);

	useEffect(() => {
		if (role === null) return;

		// Admins reach this route too, so hold the school/district redirects until the
		// server-side session sync has resolved (see AdminSessionGate).
		if (isAdminRole(role) && !isAdminSessionSynced) return;

		if (role === UserRole.SchoolAdmin && !school) {
			navigate("/selectSchool");
		}
		if (role === UserRole.DistrictAdmin && !district) {
			navigate("/selectDistrict");
		}

		// For non-admin users, require course selection
		if (!course && courseRequired && !isAdminRole(role)) {
			navigate("/courses");
		}
	}, [role, course, school, district, isAdminSessionSynced]);

	if (shouldGate) return <AdminSessionLoading />;

	return <Outlet />;
}
